export default "__VITE_PUBLIC_ASSET__b82952e7__"